import { CurrencysEnum, SwiperSortingOptionsEnum } from './constantsEnum';
import page2 from '@/views/home/page2.vue';
import page3 from '@/views/home/page3.vue';
import page4 from '@/views/home/page4.vue';
import page5 from '@/views/home/page5.vue';
import page6 from '@/views/home/page6.vue';
import page7 from '@/views/home/page7.vue';
import page8 from '@/views/home/page8.vue';
import UseCasesLayout from '@/views/home/useCasesLayout.vue';
import chinaMap from '@/views/home/chinaMap.vue';
import RechargeCenter from '@/views/home/recharge-center/index.vue';
import AdvantagesLayout from '@/views/home/advantagesLayout.vue';
import ProcessLayout from '@/views/home/processLayout.vue';
import commentWallLayout from '@/views/home/commentWallLayout/index.vue';
// 预设主题色
export const themeColors = [
  { value: 'default', color: '#4091f7' },
  { value: 'green', color: '#60ac80' },
  { value: 'volcano', color: '#e85f33' },
  { value: 'pink', color: '#d84493' },
  { value: 'mingQing', color: '#13C2C2' },
  { value: 'light', color: '#409eff' },
  { value: 'dusk', color: '#e13c39' },
  { value: 'auroraGreen', color: '#60ac80' },
  { value: 'saucePurple', color: '#693ac9' },
  { value: 'skyBlue', color: '#115CAD' },
  { value: 'ruby', color: '#e53935' },
  { value: 'amber', color: '#ffb300' },
  { value: 'emerald', color: '#00bfa5' },
  { value: 'indigo', color: '#3949ab' },
  { value: 'coral', color: '#ff7043' },
  { value: 'lavender', color: '#9575cd' },
  { value: 'turquoise', color: '#26c6da' },
  { value: 'lime', color: '#c0ca33' },
  { value: 'bronze', color: '#bf8970' },
  { value: 'slate', color: '#607d8b' },
  { value: 'royalBlue', color: '#1976d2' },
  { value: 'violet', color: '#8e24aa' },
  { value: 'sunset', color: '#ff9800' },
  { value: 'mint', color: '#66bb6a' },
  { value: 'rose', color: '#ec407a' },
  { value: 'aqua', color: '#00b8d4' },
  { value: 'coffee', color: '#795548' },
  { value: 'matcha', color: '#8bc34a' },
  { value: 'burgundy', color: '#880e4f' },
  { value: 'silver', color: '#9e9e9e' },
  { value: 'crimson', color: '#d32f2f' },
  { value: 'scarlet', color: '#f44336' },
  { value: 'cherry', color: '#c62828' },
  { value: 'rust', color: '#bf360c' },
  { value: 'wine', color: '#9c0000' },
  { value: 'gold', color: '#ffc107' },
  { value: 'navy', color: '#0d47a1' },
  { value: 'forest', color: '#2e7d32' },
  { value: 'plum', color: '#6a1b9a' },
  { value: 'charcoal', color: '#424242' },
  { value: 'peach', color: '#ffab91' },
  { value: 'azure', color: '#29b6f6' },
  { value: 'persimmon', color: '#ff5722' },
  { value: 'iris', color: '#5c6bc0' },
  { value: 'mango', color: '#fb8c00' },
];
// Logo渐变起始色选项
export const gradientStartColors = [
  { value: 'blue', color: '#3273c6' },
  { value: 'green', color: '#4d8a67' },
  { value: 'purple', color: '#5429a9' },
  { value: 'orange', color: '#e67300' },
  { value: 'pink', color: '#c23670' },
  { value: 'teal', color: '#0e9b9b' },
  { value: 'red', color: '#c23535' },
  { value: 'ruby', color: '#b71c1c' },
  { value: 'amber', color: '#ff8f00' },
  { value: 'emerald', color: '#00897b' },
  { value: 'indigo', color: '#283593' },
  { value: 'coral', color: '#e64a19' },
  { value: 'lavender', color: '#7e57c2' },
  { value: 'turquoise', color: '#00acc1' },
  { value: 'lime', color: '#afb42b' },
  { value: 'bronze', color: '#a47059' },
  { value: 'slate', color: '#455a64' },
  { value: 'royalBlue', color: '#0d47a1' },
  { value: 'violet', color: '#6a1b9a' },
  { value: 'sunset', color: '#ef6c00' },
  { value: 'mint', color: '#388e3c' },
  { value: 'rose', color: '#c2185b' },
  { value: 'aqua', color: '#006064' },
  { value: 'coffee', color: '#4e342e' },
  { value: 'matcha', color: '#689f38' },
  { value: 'burgundy', color: '#560027' },
  { value: 'silver', color: '#616161' },
  { value: 'crimson', color: '#b71c1c' },
  { value: 'scarlet', color: '#d32f2f' },
  { value: 'cherry', color: '#b71c1c' },
  { value: 'rust', color: '#8d2600' },
  { value: 'wine', color: '#740000' },
  { value: 'gold', color: '#ff8f00' },
  { value: 'navy', color: '#002171' },
  { value: 'forest', color: '#1b5e20' },
  { value: 'plum', color: '#4a148c' },
  { value: 'charcoal', color: '#212121' },
  { value: 'peach', color: '#ff8a65' },
  { value: 'azure', color: '#0288d1' },
  { value: 'persimmon', color: '#e64a19' },
  { value: 'iris', color: '#3949ab' },
  { value: 'mango', color: '#ef6c00' },
];
export const screenComponentsArr = [
  {
    label: SwiperSortingOptionsEnum.ENTERPRISE_INTELLIGENCE_TRANSFORMATION, //从AI人才培养到企业智能转型
    value: page2,
  },
  {
    label: SwiperSortingOptionsEnum.AIGC_SAAS_CLOUD_PLATFORM, //aigc-saas云平台
    value: page3,
  },
  {
    label: SwiperSortingOptionsEnum.DIGITAL_HUMAN_LIVE_STREAMING_OPERATIOn, //数字人直播运营
    value: page4,
  },
  {
    label: SwiperSortingOptionsEnum.INTELLIGENT_AGENT_DEVELOPMENT, //智能体开发
    value: page5,
  },
  {
    label: SwiperSortingOptionsEnum.EXECUTION_STANDARDS, //执行工信人才培养标准
    value: page6,
  },
  {
    label: SwiperSortingOptionsEnum.NATIONAL_OPERATION_CENTER_COVERAGE, //全国运营中心覆盖
    value: chinaMap,
  },
  {
    label: SwiperSortingOptionsEnum.INDUSTRY_PARTNER_SUPPORT, //产业合作伙伴支持
    value: page7,
  },
  {
    label: SwiperSortingOptionsEnum.CONSULT_NOW, //立即联系
    value: page8,
  },
  {
    label: SwiperSortingOptionsEnum.DIGITAL_HUMAN_APPLICATION_SCENARIOS, //数字人使用场景
    value: UseCasesLayout,
  },
  {
    label: SwiperSortingOptionsEnum.RECHARGECENTER, //选择计划
    value: RechargeCenter,
  },
  {
    label: SwiperSortingOptionsEnum.PRODUCT_COMPARISON, //产品优势对比
    value: AdvantagesLayout,
  },
  {
    label: SwiperSortingOptionsEnum.PRODUCTION_PROCESS, //制作步骤
    value: ProcessLayout,
  },
  {
    label: SwiperSortingOptionsEnum.USER_FEEDBACK, //用户反馈
    value: commentWallLayout,
  },
];
//数字仓所用到的视频和照片
export const getFutureVideo = () => {
  const video = [
    {
      title: '交互数字人-产品优势-数字永生奶奶孙子',
      poster: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/znhd.png',
      url: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/znhd.mp4',
    },
    {
      title: '优秀案例-数字人直播应用-教育直播',
      poster: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/dmhd.png',
      url: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/dmhd.mp4',
    },
    {
      title: '交互数字人-产品优势-数字永生奶奶孙子',
      poster: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/gjchd.png',
      url: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/gjchd.mp4',
    },
    {
      title: '优秀案例-数字人直播应用-教育直播',
      poster: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/qfyd.png',
      url: 'https://iiii-clone.oss-cn-shenzhen.aliyuncs.com/web/nbweb/assets/video/qfyd.mp4',
    },
  ];
  return video;
};
// 本地存储 Key
export const CONFIG_KEY = 'system-config';
export const AliyunOssUrl = 'https://oss.iiii.com/web/';
//   货币符号
export const currencySymbolArr = [
  {
    name: CurrencysEnum.CNY,
    value: '¥',
  },
  {
    name: CurrencysEnum.USD,
    value: '$',
  },
  {
    name: CurrencysEnum.TWD,
    value: 'NT$',
  },
  {
    name: CurrencysEnum.MYR,
    value: 'RM',
  },
];
